module.exports = __webpack_public_path__ + "media/icons/arrow-btn-baner@3x-c39cffc7.svg";